/**
 * Shared coordinate resolution and deduplication logic.
 */
export function resolveMapPoints(data) {
  const resolved = [];
  const coordinatesCount = {};

  if (Array.isArray(data?.points)) {
    data.points.forEach((pt, idx) => {
      const rawLat = pt?.latitude ?? pt?.lat ?? pt?.profile?.latitude ?? pt?.profile?.lat;
      let lat;
      if (rawLat !== null && rawLat !== undefined && rawLat !== "") {
        lat = Number(rawLat);
      }

      const rawLng = pt?.longitude ?? pt?.lng ?? pt?.profile?.longitude ?? pt?.profile?.lng;
      let lng;
      if (rawLng !== null && rawLng !== undefined && rawLng !== "") {
        lng = Number(rawLng);
      }

      if (lat !== undefined && !isNaN(lat) && isFinite(lat) &&
        lng !== undefined && !isNaN(lng) && isFinite(lng)) {
        const coordKey = `${lat.toFixed(6)},${lng.toFixed(6)}`;
        const count = coordinatesCount[coordKey] ?? 0;
        coordinatesCount[coordKey] = count + 1;

        resolved.push({
          ...pt,
          _resolvedLat: lat,
          _resolvedLng: lng,
          _resolvedIndex: idx,
          _duplicateIndex: count
        });
      }
    });
  }
  return resolved;
}

/**
 * Calculate offset for duplicate coordinates.
 */
export function getOffsetCoordinate(lat, lng, duplicateIndex) {
  if (duplicateIndex > 0) {
    const angle = (duplicateIndex * 2 * Math.PI) / 8;
    const radius = 0.00008 * Math.ceil(duplicateIndex / 8);
    return {
      lat: lat + Math.sin(angle) * radius,
      lng: lng + Math.cos(angle) * radius
    };
  }
  return { lat, lng };
}
